const ENV = process.env.NEXT_PUBLIC_NODE_ENV

export const isProd = ENV === 'PROD'
